import React from "react";
import { DimensionContext } from "@/types/data";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { InsightsSection } from ".";
import { useTranslation } from "react-i18next";
import { useValuesInsights } from "@/shared/hooks/insights/useValuesInsights";
import { SectionHeader } from "@/shared/ui/SectionHeader";
import { Column } from "@/shared/ui";

interface ValuesInsightsSectionProps {
  dimensions?: DimensionWithScores[];
  context?: DimensionContext;
  defaultPersonId?: number;
}

export const ValuesInsights = (props: ValuesInsightsSectionProps) => {
  const { dimensions, context = "person", defaultPersonId } = props;

  const { t } = useTranslation();

  // Map DimensionContext to the hook's expected context type
  const hookContext =
    context === "user_in_team" ? "person" : (context as DimensionContext);

  const insights = useValuesInsights({
    dimensions: dimensions || [],
    context: hookContext,
    defaultPersonId,
  });

  const getTopsLabel = () => {
    // Implement context specific labels if needed
    return t("values_insights.important_values");
  };

  const getBottomsLabel = () => {
    // Implement context specific labels if needed
    return t("values_insights.least_important_values");
  };

  const filterButtons = [
    { key: "all", label: t("competency_insights.all_insights") },
    { key: "important_values", label: getTopsLabel() },
    { key: "least_important_values", label: getBottomsLabel() },
  ];

  return (
    <Column className="mt-16 print:hidden">
      <SectionHeader
        title={t("profile.values_insights_title")}
        subtitle={t("profile.values_insights_description", {
          context: t(`context_label.${context}_posessive`),
        })}
        className="mb-0"
      />
      <InsightsSection
        insights={insights}
        filters={filterButtons}
        context={context}
      />
    </Column>
  );
};
